import { COMPANY, PRINCIPLES, PROCESS } from './content';

export function Approach() {
  return (
    <>
      <section className="page-head">
        <p className="eyebrow">Approach</p>
        <h1>How we work, and what it costs</h1>
        <p className="hero-lead">
          Software goes wrong in predictable ways: unclear scope, a price that
          moves, and nobody owning it after launch. Here is how we avoid each
          of those.
        </p>
      </section>

      <section className="band">
        <h2 className="band-title">The process</h2>
        <ol className="steps">
          {PROCESS.map((p) => (
            <li key={p.step}>
              <span className="step-num">{p.step}</span>
              <div>
                <h3>{p.title}</h3>
                <p>{p.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>

      <section className="band">
        <h2 className="band-title">What we commit to</h2>
        <div className="grid-2">
          {PRINCIPLES.map((p) => (
            <article key={p.title} className="tile">
              <h3>{p.title}</h3>
              <p>{p.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="band">
        <h2 className="band-title">Pricing</h2>
        <div className="prose">
          <p>
            We quote per project, in writing, before starting. The price
            depends on scope, and we would rather reduce scope than inflate an
            estimate to cover uncertainty.
          </p>
          <p>
            We do not publish a rate card, because a number on a page that
            ignores what you are building is not useful to you. What we will
            say is that the quote is fixed for the scope agreed, and if the
            scope changes you will see a revised price before the work happens
            &mdash; not on the invoice.
          </p>
          <p>
            Ongoing maintenance is priced separately and is optional. If you
            would rather run the software yourself, we hand it over with
            documentation and no strings.
          </p>
        </div>
      </section>

      <section className="cta-band">
        <h2>Ready for a number?</h2>
        <p>Send the project description and you will get scope, price and a timeline.</p>
        <a className="btn-primary" href={`mailto:${COMPANY.email}`}>
          {COMPANY.email}
        </a>
      </section>
    </>
  );
}
